/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/*jshint esversion: 6 */

// Plugin Name:		MINDGALLERY
// Plugin URI:		https://mindfolio.webmajstr.cz/mindgallery
// Description:		Smooth Gallery carefully crafted for Mindfolio WP Theme
// Author:			Jakub Runda
// Author URI:		http://webmajstr.cz
// Version:			1.9.5

import mind_gallery from './mg-transition';


export default class MG_Server {

	constructor() {

		console.log('MIND GALLERY SERVER IS HERE');

	}

	serve() {



		jQuery(() => {

			const Gs = this._get_galleries();

			Gs.map(Gallery_Object => {

				const MindGallery = new mind_gallery(Gallery_Object);
				MindGallery.init();

			});
		});
	}

	_get_galleries() {

		const galleries = document.querySelectorAll('.mindgallery-container');


		let Gallery_Object_List = [];

		galleries.forEach(element => {


			const atts = element.attributes;
			const n = atts.length;

			let Gallery_Data_Object = {};

			for (let i = 0; i < n; i++) {

				Gallery_Data_Object[atts[i].nodeName] = this.escapeHtml(element.getAttribute(atts[i].nodeName));

			}
			Gallery_Data_Object = this._relevate_object_data(Gallery_Data_Object);

			console.log(Gallery_Data_Object);

			Gallery_Object_List.push(Gallery_Data_Object);

		});

		return Gallery_Object_List;

	}

	_relevate_object_data(obj) {

		obj.controls = obj.controls == 'false' ? false : obj.controls;
		obj.info = obj.info == 'false' ? false : obj.info;
		obj.counter = true;
		obj.info_collapse = true;
		obj.thumbnails = this.get_bool(obj.thumbnails);
		obj.control_panel = obj.control_panel == 'false' ? false : obj.control_panel;
		obj.posts_navigation = true;
		obj.arrow_control = this.get_bool(obj.arrow_control);
		obj.panel_navigation = this.get_bool(obj.panel_navigation);
		obj.autoplay = this.get_bool(obj.autoplay);
		obj.autodelay = parseInt(obj.autodelay);
		obj.thumbs_width = parseInt(obj.thumbs_width);
		obj.thumbs_height = parseInt(obj.thumbs_height);
		obj.button_width = parseInt(obj.button_width);
		obj.button_height = parseInt(obj.button_height);
		obj.items_autosize = this.get_bool(obj.items_autosize);
		obj.first_image = parseInt(obj.first_image);

		return obj;

	}

	get_bool(val) {
		return val == 'true' ? true : false;
	}

	escapeHtml(html) {

		var text = document.createTextNode(html);

		var p = document.createElement('p');

		p.appendChild(text);

		return p.innerHTML;

	}

}